module.exports = __webpack_public_path__ + "static/d60aac1737178c436c1a0d3f9853b14abac2875ef86dcb86c9a7ba76288f01a0-0b6741c93aa72c2fc36b3c11b3ca9050.png";